
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AddSubRepositoryModal',

  props: {
    primaryActionLoading: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: 'Something went wrong while creating the sub-repository.'
    },
    monorepoName: {
      type: String,
      required: true
    },
    monorepoDefaultBranch: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      branch: '',
      subRepositoryPath: ''
    }
  },

  created() {
    this.branch = this.monorepoDefaultBranch
  },

  methods: {
    primaryActionHandler() {
      this.$emit('primary', {
        branch: this.branch,
        subRepositoryPath: this.subRepositoryPath
      })
    }
  }
})
